import { useNavigate, useParams } from "react-router-dom"
import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader, Row, Col, Container } from "reactstrap"
import { useGetSessionEventDetailsQuery, usePostVisitorListMutation, usePutSessionEventIsHideMutation } from "../../features/CallApi";
import LoadScreen from "../UI/LoadScreen";
import { SessionEventType } from "./SessionEventType";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useEffect, useState } from "react";
import { disable } from "workbox-navigation-preload";
import { GetBlank } from "./GetBlank";
import { Form } from "react-bootstrap";



export const SessionEventDetails = ({ token }) => {

    const navigate = useNavigate();
    const { id } = useParams()
    const { data, isLoading, refetch } = useGetSessionEventDetailsQuery(id)
    const [putSessionEventIsHide, { isLoading: putingIsHide }] = usePutSessionEventIsHideMutation()
    const [postingList, setPostingList] = useState(false)
    const [getReport, setGetReport] = useState(false)
    const [getReportEvents, setGetReportEvents] = useState(false)
    const [isHide, setIsHide] = useState(false)
    const [firstLoad, setFirstLoad] = useState(true)
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const getBlank = (typeId) => {
        console.log(typeId)
        const link = GetBlank(typeId)
        console.log(link)

        fetch(link).then(response => response.blob())
            .then(blob => {
                console.log(blob)
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "blank.xlsx";
                link.click();
            })
            .catch(console.error);
    }
    const postList = (data) => {
        setPostingList(true)

        const formData = new FormData()

        formData.append("id", parseInt(data.id))
        formData.append("file", data.visitorsListImport[0])

        console.log(data.typeOfEvent)


        let link;
        switch (parseInt(data.typeOfEvent)) {
            case 3: link = "/api/sessionevents/importlistshow";
                break;
            case 5: link = "/api/sessionevents/importlistshow";
                break;
            default: link = '/api/sessionevents/importlist';
        }

        console.log(link)

        axios.post(link, formData, {
            headers: {
                Authorization: "Bearer " + token,
                // 'Content-Type': 'multipart/form-data',
                // encType: "application/x-www-form-urlencoded",
            }
        }).then(() => {
            alert("Список загружен успешно")
            setPostingList(false)
            reset();
        }).catch((e) => {
            alert("Ошибка, проверти корректность файла")
            setPostingList(false)
            console.log(e)
        })
    }
    const getExcelExportVisitors = () => {
        setGetReport(true)
        fetch(`/api/sessionevents/exportvisitorlist/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "VisitorList" + id + ".xlsx";
                link.click();
                setGetReport(false)
            })
            .catch((e) => {
                console.error(e)
                setGetReport(false)
            });
    }
    const getExcelExportVisitorsEvents = () => {
        setGetReportEvents(true)
        fetch(`/api/sessionevents/export-visitor-list-events/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "VisitorListEvents" + id + ".xlsx";
                link.click();
                setGetReportEvents(false)
            })
            .catch((e) => {
                console.error(e)
                window.alert(e.data.title)
                setGetReportEvents(false)
            });
    }
    useEffect(() => {
        if (!firstLoad) {

        } else {
            setFirstLoad(false)
        }

    }, [isHide])

    useEffect(() => {
        if (data) {
            setIsHide(data.isHide)
        }
    }, [data])

    return (
        <Row>
            <Col md={{ offset: 2, size: 8 }} xl={{ offset: 3, size: 6 }}>
                <Container>
                    {!isLoading ?

                        <Card>
                            <CardHeader>Данные списка"</CardHeader>
                            <CardBody>
                                <table className="mb-3">
                                    <tbody>
                                        <tr>
                                            <td className="p-1 text-end">Название:</td>
                                            <td className="p-1">{data.title}</td>
                                        </tr>
                                        <tr>
                                            <td className="p-1 text-end">Дата мероприятия:</td>
                                            <td className="p-1">{data.dateEvent}</td>
                                        </tr>
                                        <tr>
                                            <td className="p-1 text-end">Статус:</td>
                                            <td className="p-1">{data.status ? <span className="text-success">Ативен</span> : <span className="text-secondary">Не активен</span>}</td>
                                        </tr>
                                        <tr>
                                            <td className="p-1 text-end">Тип списка:</td>
                                            <td className="p-1"><SessionEventType eventType={data.typeOfEvent} /></td>
                                        </tr>
                                    </tbody>
                                </table>
                                <Button color="info" size="sm" className="text-white mb-3" onClick={() => { getBlank(data.typeOfEvent) }}>
                                    Бланк для загрузки
                                </Button>
                                <form onSubmit={handleSubmit(postList)} encType="multipart/form-data">
                                    <div className="mb-3">
                                        <input hidden value={data.id} {...register("id")} />
                                        <input hidden value={data.typeOfEvent}  {...register("typeOfEvent")} />
                                        <label htmlFor="formFile" className="form-label">Загрузить список</label>
                                        <input {...register("visitorsListImport", { required: { value: true, message: "Загрузите файл" } })} accept=".xlsx" className="form-control form-control-sm  flex-grow-1" type="file" id="formFile" />
                                        {errors.visitorsListImport && <div><span className='text-danger'>{errors.visitorsListImport?.message}</span></div>}

                                    </div>
                                    <Button disabled={postingList} color="success" size="sm">
                                        {postingList ?
                                            <div className="text-center">
                                                <div className="spinner-border spinner-border-sm me-3 ms-3 mt-1 text-light" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div> :
                                            "Загрузить"
                                        }
                                    </Button>
                                </form>
                                <ButtonGroup>
                                    <Button disabled={getReport} size="sm" className="mt-3" color="success" onClick={() => getExcelExportVisitors()}>
                                        {getReport ?
                                            <div className="text-center">
                                                <div className="spinner-border spinner-border-sm me-3 ms-3 mt-1 text-light" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div> :
                                            "Сохранить отчет Covid-тесты"
                                        }
                                    </Button>
                                    <Button disabled={getReportEvents} size="sm" className="mt-3" color="success" onClick={() => getExcelExportVisitorsEvents()}>
                                        {getReportEvents ?
                                            <div className="text-center">
                                                <div className="spinner-border spinner-border-sm me-3 ms-3 mt-1 text-light" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div> :
                                            "Сохранить отчет Events"
                                        }

                                    </Button>
                                </ButtonGroup>
                                <Form.Check className="mt-3" label="Скрыть список" type="switch" checked={isHide} onChange={() => {
                                    if (window.confirm("Скрыть список?")) {
                                        putSessionEventIsHide(id).then(() => {
                                            refetch()
                                        })
                                    }
                                }} />
                            </CardBody>
                            <CardFooter>
                                <ButtonGroup>
                                    <Button size="sm" color="success" onClick={() => { navigate(`/admin/sessionevents/list/${data.id}`) }}>Список</Button>
                                    <Button size="sm" color="warning" onClick={() => { navigate(`/admin/sessionevents/edit/${data.id}`) }}>Редактировать</Button>
                                    <Button size="sm" color="secondary" onClick={() => { navigate("/admin/sessionevents") }}>Назад</Button>
                                </ButtonGroup>
                            </CardFooter>
                        </Card>
                        :
                        <LoadScreen />
                    }
                </Container>
            </Col>
        </Row>
    )
}